import { html } from "lit";
import { Template as HeaderTemplate, storyArgs } from "./header";
import { Template as FooterTemplate } from "./footer";
import { Template as MarginalColumnTemplate } from "./marginal-column";
import { Template as SidebarTemplate } from "./sidebar";

const header = () => html` ${HeaderTemplate(storyArgs)} `;
const footer = () => html` ${FooterTemplate()} `;
const marginalColumn = () => html` ${MarginalColumnTemplate()} `;
const sidebar = () => html` ${SidebarTemplate()} `;

export const page = (content, verticalOffset = 0) => {
    const section =
        verticalOffset !== undefined
            ? html`<section
                  id="mainContent"
                  class="ux-iws-nav-blur-page"
                  style="padding-top: ${verticalOffset}px;"
              >
                  ${content}
              </section>`
            : html`<section id="mainContent" class="ux-iws-nav-blur-page">
                  ${content}
              </section>`;
    return html`
        <div class="ux-iws-page-wrapper">
            ${header()} ${section} ${footer()}
        </div>
    `;
};

export const pageWithMarginalColumn = (content) => {
    return html`
        <div class="ux-iws-page-wrapper">
            ${header()}
            <section id="mainContent" class="ux-iws-nav-blur-page">
                <div class="ux-t-container-full">
                    <div class="ux-row ux-gutter-zero">
                        <div class="ux-col-12 ux-col-xl-9">${content}</div>
                        <div class="ux-col-3">
                            <ux-iws-marginal-column
                                button-label="Service & Contact"
                                >${marginalColumn()}</ux-iws-marginal-column
                            >
                        </div>
                    </div>
                </div>
            </section>
            ${footer()}
        </div>
    `;
};

export const pageWithMarginalColumnFullWidth = (
    content,
    verticalOffset = 0
) => {
    const section =
        verticalOffset !== undefined
            ? html`<section
                  id="mainContent"
                  class="ux-iws-nav-blur-page"
                  style="padding-top: ${verticalOffset}px;"
              >
                  ${content}
                  <ux-iws-marginal-column
                      button-label="Service & Contact"
                      show-button-on-full-width
                      >${marginalColumn()}</ux-iws-marginal-column
                  >
              </section>`
            : html`<section id="mainContent" class="ux-iws-nav-blur-page">
                  ${content}
                  <ux-iws-marginal-column
                      button-label="Service & Contact"
                      show-button-on-full-width
                      >${marginalColumn()}</ux-iws-marginal-column
                  >
              </section>`;
    return html`
        <div class="ux-iws-page-wrapper">
            ${header()} ${section} ${footer()}
        </div>
    `;
};

export const pageWithSidebar = (content) => {
    return html`
        <div class="ux-iws-page-wrapper">
            ${header()}
            <section id="mainContent" class="ux-iws-nav-blur-page">
                ${content} ${sidebar()}
            </section>
            ${footer()}
        </div>
    `;
};

export const pageStoryDecorator = (Story) => html`
    <div class="ux-t-container-full">
        ${header()}
        <section id="mainContent" class="ux-iws-nav-blur-page">
            ${Story()}
        </section>
        ${footer()}
    </div>
`;

export const getIframePageDecorators = () => {
    return typeof window !== undefined &&
        window.top.location.pathname.includes("iframe.html")
        ? [pageStoryDecorator]
        : [];
};

export default page;
